import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  ListSubheader,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { makeStyles } from "@mui/styles";
import { useLocation, useHistory } from "react-router-dom";

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  title: {
    flexGrow: 1,
  },
  button: {
    fontWeight: "bold",
  },
}));

function ResponsiveDrawer(props) {
  const { children } = props;
  const classes = useStyles();
  const { pathname } = useLocation();
  const history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleClick = (to) => {
    if (to === pathname) {
      return;
    }
    history.push(to);
  };

  const drawer = (
    <>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/"}
            onClick={() => {
              handleClick("/");
            }}
          >
            <ListItemText primary="ホーム" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListSubheader>検索</ListSubheader>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/reproduce-search"}
            onClick={() => {
              handleClick("/reproduce-search");
            }}
          >
            <ListItemText primary="組み合わせ再現漢方検索" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/component-search"}
            onClick={() => {
              handleClick("/component-search");
            }}
          >
            <ListItemText primary="構成生薬利用漢方検索" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/relevent-search"}
            onClick={() => {
              handleClick("/relevent-search");
            }}
          >
            <ListItemText primary="類似漢方検索" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListSubheader>証診断支援</ListSubheader>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/sho-diagnosis/integrated"}
            onClick={() => {
              handleClick("/sho-diagnosis/integrated");
            }}
          >
            <ListItemText primary="組み合わせ弁証支援" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/sho-diagnosis/hakko"}
            onClick={() => {
              handleClick("/sho-diagnosis/hakko");
            }}
          >
            <ListItemText primary="八綱弁証支援" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/sho-diagnosis/kiketsushineki"}
            onClick={() => {
              handleClick("/sho-diagnosis/kiketsushineki");
            }}
          >
            <ListItemText primary="気血津液弁証支援" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/sho-diagnosis/zoufu"}
            onClick={() => {
              handleClick("/sho-diagnosis/zoufu");
            }}
          >
            <ListItemText primary="臓腑弁証支援" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/sho-diagnosis/rokkei"}
            onClick={() => {
              handleClick("/sho-diagnosis/rokkei");
            }}
          >
            <ListItemText primary="六経弁証支援" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListSubheader>データ</ListSubheader>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/otc-kampo"}
            onClick={() => {
              handleClick("/otc-kampo");
            }}
          >
            <ListItemText primary="一般用漢方製剤製造販売承認基準" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/all-kampo"}
            onClick={() => {
              handleClick("/all-kampo");
            }}
          >
            <ListItemText primary="漢方方剤" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/all-syoyaku"}
            onClick={() => {
              handleClick("/all-syoyaku");
            }}
          >
            <ListItemText primary="生薬" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/tsumura-kampo"}
            onClick={() => {
              handleClick("/tsumura-kampo");
            }}
          >
            <ListItemText primary="ツムラ医療用漢方製剤" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/terms"}
            onClick={() => {
              handleClick("/terms");
            }}
          >
            <ListItemText primary="利用規約" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/privacy"}
            onClick={() => {
              handleClick("/privacy");
            }}
          >
            <ListItemText primary="プライバシーポリシー" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={pathname === "/links"}
            onClick={() => {
              handleClick("/links");
            }}
          >
            <ListItemText primary="関連リンク" />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title}>
            カンポウズ
          </Typography>
          {/*state.user.isSignIn ? (
            <Button
              variant="contained"
              className={classes.button}
              onClick={() => Auth.signOut()}
            >
              ログアウト
            </Button>
          ) : (
            <Button
              variant="contained"
              className={classes.button}
              onClick={() => Auth.federatedSignIn()}
            >
              ログイン
            </Button>
          )*/}
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer}>
        <Box sx={{ display: { sm: 'none' } }}>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Box>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ResponsiveDrawer;
